import type { IconName } from "@similarweb/icons";

import { ContactEntryType } from "app/pages/sales-intelligence/sub-modules/contacts-search/types/common";

export const CONTACT_TYPE_TO_ICON: Record<ContactEntryType, IconName> = {
    [ContactEntryType.Email]: "email",
    [ContactEntryType.Mobile]: "mobile-ios",
    [ContactEntryType.Direct]: "phone-outlined",
};
